<template>
  <div>
    <div class="position-relative">
      <section class="section section-sm bg-custom-bg-color" style="margin-top: 90px">
        <div class="container p-0">

          <div class="row align-items-center mx-0" style="row-gap: 0.5rem;">
            <div class="col-6 col-md-3">
              <AvailableDatePicker
                  precision="month"
                  v-model="month"
                  :available-dates="availableMonths"
                  @change="applyFilters"
              />
            </div>
          </div>

          <div class="mt-3"/>

          <div class="card shadow">
            <div class="card-body">
              <h2 v-text="'我的帳單'"/>
              <div class="mt-3"/>
              <div v-if="!loading && bill_list.length === 0"
                   class="text-main-color font-weight-500 text-center font-size-18">
                目前沒有帳單
              </div>
              <div class="d-grid grid-gap">
                <div v-for="(item, index) in bill_list" :key="index" class="grid-item">
                  <DownloadItem :title="item.title" :create_date="item.bill_date" :file-count="item.file_count"
                                :on-download="() => downloadBill(item.id)"/>
                </div>
              </div>
              <div class="mt-4"/>
              <div v-if="page_count > 1">
                <base-pagination :page-count="page_count" align="center" :value="page"
                                  @input="onPageChange"/>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  </div>
</template>

<script>
import DownloadItem from "@/views/components/elements/DownloadItem";
import AvailableDatePicker from "@/components/AvailableDatePicker.vue";
import * as Api from "@/util/http_api";

export default {
  name: "CustomerBillsView",
  components: {
    DownloadItem,
    AvailableDatePicker,
  },
  data() {
    return {
      month: '',
      // 這家店真的有帳單資料的月份；月份選擇器只開放這些月份
      availableMonths: [],
      page: 1,
      page_count: 1,
      bill_list: [],
      loading: false,
      itemsPerPage: 8,
    };
  },
  async created() {
    await this.fetchAvailableMonthsAndDefault();
    this.fetchBills(1);
  },
  methods: {
    onPageChange(page) {
      this.page = page;
      this.fetchBills(page);
    },
    // 預設優先選當月；當月沒有資料時退而取最新一個有資料的月份
    async fetchAvailableMonthsAndDefault() {
      this.availableMonths = await Api.getCustomerBillMonths();
      const now = new Date();
      const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
      if (this.availableMonths.includes(currentMonth)) {
        this.month = currentMonth;
      } else {
        this.month = this.availableMonths.length > 0 ? this.availableMonths[0] : '';
      }
    },
    // 月份改變時，目前分頁條件已經不一定有效，重置成第 1 頁
    applyFilters() {
      this.page = 1;
      this.fetchBills(1);
    },
    formatDateOnly(v) {
      if (!v) return '';
      const d = new Date(v);
      return d.getFullYear() + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + String(d.getDate()).padStart(2, '0');
    },
    // 一筆帳單紀錄對應一張卡片；紀錄可能同時掛多個檔案（下載時後端會打包成 zip），
    // 也可能還沒上傳檔案（顯示「檔案準備中」）。用列數（而非檔案數）分頁，
    // 才不會跟後端 API 的 offset/limit 對不上。
    mapBillsToDisplayItems(rows) {
      return rows.map(row => ({
        id: row.id,
        title: row.title,
        bill_date: this.formatDateOnly(row.bill_date),
        file_count: Array.isArray(row.Files) ? row.Files.length : 0,
      }));
    },
    async downloadBill(id) {
      try {
        await Api.downloadCustomerBillFiles(id);
      } catch (e) {
        console.error('downloadBill error', id, e);
        alert('下載失敗，請稍後再試');
      }
    },
    async fetchBills(page) {
      this.loading = true;
      try {
        const offset = (page - 1) * this.itemsPerPage;
        const listData = await Api.getCustomerBills({
          month: this.month,
          limit: this.itemsPerPage,
          offset,
        });
        this.bill_list = this.mapBillsToDisplayItems(listData.items);
        this.page_count = Math.max(1, Math.ceil(listData.total / this.itemsPerPage));
      } catch (e) {
        console.error('fetchBills error', e);
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style scoped>

.grid-gap {
  grid-gap: 10px;
}

.grid-item {
  padding: 0px;
}

</style>
